import React from 'react'
import { Flex } from '@chakra-ui/react'

export const Page = props => <Flex direction='column' width='full' flex={1} p={3} {...props} />

export default Page
